import React, { useMemo } from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Link } from 'react-router-dom';
import { Translate} from '../../config/TranslationProvider';
import L from 'leaflet';
import config from '../../config/config';
import { useAppConfiguration } from '../../AppConfiguration';
import { getMediaUrl } from '../../api/hooks';
import getAssetUrl from '../../util/getAssetUrl';

const {images: {icons: {markerIcons, defaultIcon}}} = config;

const getIconByTags = tags => {
    // Search for tags that fit our special marker icons
    for (const markerIcon of markerIcons) {
        if (tags.find(tag => tag.title === markerIcon[0])) {
            return markerIcon[1];
        }
    }

    return false;
};

const LocationMarker = ({location, popup = false}) => {
    const {mapConfiguration: {enableCustomLocationMarkers}} = useAppConfiguration();

    const image = location.medialist && location.medialist[0];
    const icon = useMemo(() => {
        const customIcon = enableCustomLocationMarkers && getIconByTags(location.tags);

        if (!customIcon) {
            // Use default icon
            return L.icon({
                iconUrl: getAssetUrl(defaultIcon),
                iconSize: [25, 41],
                iconAnchor: [13, 40], // Pointing position of the icon marker
                popupAnchor: [0, -40], // Position where the popup should point too, relative to the icon anchor
            });
        }

        // Use custom icon
        return L.icon({
            iconUrl: getAssetUrl(customIcon),
            iconSize: [20, 20],
            iconAnchor: [10, 10], // Pointing position of the icon marker
            popupAnchor: [0, -12], // Position where the popup should point too, relative to the icon anchor
        });
    }, [enableCustomLocationMarkers, location.tags]);

    return (
        <Marker position={[location.lat, location.lng]} icon={icon}>
            {popup ?
                <Popup>
                    {image && (
                        <img src={getMediaUrl(image.id, image.context, 'medium')} alt="event_image" />
                    )}

                    <h4 className="atbd_listing_title">
                        <Link to={'/locations/' + location.id}>{location.title}</Link>
                    </h4>
                    <div className="atbd_listing_data_list">
                        <ul>
                            <li>
                                <p>
                                    <span className="la la-map-marker" />
                                    {location.address}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span className="la la-building" />{location.zip}, {location.city}
                                </p>
                            </li>
                            <li style={{paddingTop: '10px'}}>
                                <Link to={'/locations/' + location.id} >
                                    <Translate value="read_more" />
                                </Link>
                            </li>
                        </ul>
                    </div>

                </Popup>
                :
                <Popup>
                    <div className="atbd_listing_data_list">
                        <ul>
                            <li>{location.address + ', ' + location.city}</li>
                        </ul>
                    </div>
                </Popup>}
        </Marker>
    );
};

export default React.memo(LocationMarker);
